/**
 * Keeps Box sync exclusion rules independent of presentation so every editor
 * applies the same backend-compatible limits before replacing an exclusion list.
 * Known failures return stable discriminants for localized copy; regex syntax
 * failures preserve the browser's compiler detail for direct display.
 */

export const MAX_EXCLUDED_ENTRIES = 100;
export const MAX_PATHNAME_PATTERN_LENGTH = 512;

export const ExclusionValidationMessages = {
  InvalidFolderId: 'invalid-folder-id',
  EmptyPathname: 'empty-pathname',
  PathnameTooLong: 'pathname-too-long',
  Duplicate: 'duplicate',
  ListFull: 'list-full',
} as const;

const BOX_FOLDER_ID_PATTERN = /^\d{1,20}$/;

export const validateFolderIdEntry = (
  value: string,
  existing: readonly string[],
): string | null => {
  if (existing.length >= MAX_EXCLUDED_ENTRIES) {
    return ExclusionValidationMessages.ListFull;
  }
  if (!BOX_FOLDER_ID_PATTERN.test(value)) {
    return ExclusionValidationMessages.InvalidFolderId;
  }
  if (existing.includes(value)) {
    return ExclusionValidationMessages.Duplicate;
  }

  return null;
};

export const validatePathnameEntry = (
  value: string,
  existing: readonly string[],
): string | null => {
  if (existing.length >= MAX_EXCLUDED_ENTRIES) {
    return ExclusionValidationMessages.ListFull;
  }
  if (value.length === 0) {
    return ExclusionValidationMessages.EmptyPathname;
  }
  if (value.length > MAX_PATHNAME_PATTERN_LENGTH) {
    return ExclusionValidationMessages.PathnameTooLong;
  }

  try {
    void new RegExp(value);
  } catch (error) {
    return String(error);
  }

  if (existing.includes(value)) {
    return ExclusionValidationMessages.Duplicate;
  }

  return null;
};
